// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__11Fz5","buttons":"PendingPaymentAlert_buttons__1oQAd"};